import { autoinject, bindable, children, computedFrom, TaskQueue } from 'aurelia-framework';
import { IReportGroupRowAM, IReportRowAM } from '../report-api';
import {
	IGeneratedRow,
	ReportTemplate,
	RowGeneratorModificationOperation
} from '../models/report-template';
import { findIndex } from 'lodash';
import { convertFinancialPrecisionToDecimals } from "../../../utils/report-utils";

@autoinject
export class ReportRowEdit {
	@bindable row: IReportRowAM;
	@bindable level = 0;
	@bindable reportTemplate: ReportTemplate;

	expanded: boolean;
	visibleRows: IReportRowAM[] = null;

	@children('report-row-edit') childRows: ReportRowEdit[] = [];

	constructor(private taskQueue: TaskQueue) {
	}

	attached() {
		if (this.findRowDeleteOperationIndex() > -1) {
			this.row['isDeleted'] = true;
		}
	}

	bind() {
		this.expanded = this.level === 0 ? true : false;

		if (this.expanded) {
			this.visibleRows = (this.row as IReportGroupRowAM).rows;
		}
	}

	@computedFrom('reportTemplate')
	get numberOfDecimals(): number {
		return convertFinancialPrecisionToDecimals(this.row, this.reportTemplate.content.source.filters.financialPrecision)
	}

	toggleExpanded(): void {
		this.expanded = !this.expanded;
		if (this.expanded) {
			this.visibleRows = (this.row as IReportGroupRowAM).rows;
		}
	}

	setExpandSelfAndChildren(expanded: boolean) {
		this.expanded = expanded;

		if (this.expanded && this.visibleRows == null) {
			this.visibleRows = (this.row as IReportGroupRowAM).rows;
			this.taskQueue.queueTask(() => this.childRows.forEach(child => { child.setExpandSelfAndChildren(expanded); }));
		} else {
			this.childRows.forEach(child => { child.setExpandSelfAndChildren(expanded); });
		}
	}

	private get generatedRow(): IGeneratedRow {
		// TODO: This is propably way too simple assumption
		return this.reportTemplate.content.rows[0] as IGeneratedRow;
	}

	private findRowDeleteOperationIndex(): number {
		return findIndex(this.generatedRow.modifications,
			mod => mod.operation === 'Delete' && mod.anchor === this.row.identifier);
	}

	toggleDelete(row: IReportRowAM) {
		if (this.generatedRow.modifications == null) {
			this.generatedRow.modifications = [];
		}

		if (this.row['isDeleted']) {
			this.generatedRow.modifications.splice(this.findRowDeleteOperationIndex());
			this.row['isDeleted'] = false;
		} else {
			const operation = {
				operation: RowGeneratorModificationOperation.Delete,
				anchor: this.row.identifier
			};

			this.generatedRow.modifications.push(operation);
			this.row['isDeleted'] = true;
		}
	}
}
